const hasContact = (patient, type) => {
    if (type === 'email') {
        return Boolean(patient?.email?.trim());
    }

    if (type === 'sms') {
        return Boolean(patient?.cellNumber?.trim());
    }

    return false;
};

const isChannelEnabled = (commPrefs, type) => {
    if (!commPrefs) {
        return true;
    }

    if (type === 'email') {
        return commPrefs.isEmail !== false;
    }

    if (type === 'sms') {
        return commPrefs.isSms !== false;
    }

    return false;
};

export const resolveGlassPickupChannel = (patient, commPrefs) => {
    if (commPrefs?.isGlass === false) {
        return null;
    }

    const canEmail = hasContact(patient, 'email') && isChannelEnabled(commPrefs, 'email');
    const canSms = hasContact(patient, 'sms') && isChannelEnabled(commPrefs, 'sms');

    if (!canEmail && !canSms) {
        return null;
    }

    if (canEmail && !canSms) {
        return 'email';
    }

    if (!canEmail && canSms) {
        return 'sms';
    }

    const channels = [
        { type: 'email', pref: Number(commPrefs?.prefEmail ?? 1) },
        { type: 'sms', pref: Number(commPrefs?.prefSms ?? 2) },
    ];

    channels.sort((left, right) => left.pref - right.pref);
    return channels[0].type;
};

export const getGlassPickupActionState = (patient, commPrefs) => {
    const reasons = [];

    if (commPrefs?.isGlass === false) {
        reasons.push('disabled in communication preferences');
    }

    const channel = resolveGlassPickupChannel(patient, commPrefs);

    if (!channel) {
        const hasEmail = hasContact(patient, 'email');
        const hasCell = hasContact(patient, 'sms');

        if (!hasEmail && !hasCell) {
            reasons.push('no email or cell number on file');
        } else if (hasEmail && !hasCell && commPrefs?.isEmail === false) {
            reasons.push('email disabled in communication preferences');
        } else if (!hasEmail && hasCell && commPrefs?.isSms === false) {
            reasons.push('SMS disabled in communication preferences');
        } else if (hasEmail && hasCell) {
            if (commPrefs?.isEmail === false) {
                reasons.push('email disabled in communication preferences');
            }
            if (commPrefs?.isSms === false) {
                reasons.push('SMS disabled in communication preferences');
            }
        }
    }

    const disabled = reasons.length > 0 || !channel;

    return {
        disabled,
        channel,
        title: disabled
            ? `Glass Pickup — ${reasons.join('; ')}`
            : `Glass Pickup via ${channel === 'email' ? 'Email' : 'SMS'}`,
    };
};
